import { useEffect, useRef, useState } from "react";
import axiosInstance from "../../utilities/Axios";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Formik } from "formik";
import * as Yup from "yup";
import { Button, FormHelperText, InputLabel, TextField } from "@mui/material";
import { EDialogAction } from "../Enum/DialogActionEnum";
import { useSnackbar } from "notistack";
import { pdfTypeEnum } from "../../Types/Enum";

const JobTiltlesDialogBox = (props: {
  open: boolean;
  onClose: any;
  data: any;
  dialogAction: EDialogAction;
}) => {
  const [jobTitle, setJobTitle] = useState(props.data);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const formRef = useRef<any>();
  const [value, setValue] = useState({});

  useEffect(() => {
    setJobTitle(props.data);
  }, [props.data]);



  const handleClose = (action: string = "closed") => {
    props.onClose(action);
  };

  const createJobTitle = async (data: any) => {
    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/job-titles`;

      const res = await axiosInstance.post(url, {
        title: data.title,
        type: data.type,
        pdf_template: data.pdf_template,
      });
      enqueueSnackbar("Job Title Created Successfully!!!", {
        variant: "success",
      });
      handleClose("created");

    } catch (err: any) {
      enqueueSnackbar(
        `Job Title Creation Unsuccessful!!! ${err.response.data.error}`,
        {
          variant: "error",
        }
      );
      console.error(err);
    }
  };
  const editJobTitle = async (data: any) => {
    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/job-titles/${jobTitle.id}`;

      await axiosInstance.put(url, {
        title: data.title,
        type: data.type,
        pdf_template: data.pdf_template,
      });

      enqueueSnackbar("Job Title Updated Successfully!!!", {
        variant: "success",
      });

      handleClose("edited");
    } catch (err: any) {
      enqueueSnackbar(
        `Job Title Updatation Unsuccessfull!!! ${err.response.data.error}`,
        {
          variant: "error",
        }
      );
    }
  };

  return (
    <>
      {" "}
      {jobTitle == null ? (
        <div></div>
      ) : (
        <Dialog
          open={props.open}
          onClose={(event, reason) => {
            if (reason != "backdropClick" && reason != "escapeKeyDown") {
              handleClose();
            }
          }}
        >
          {props.dialogAction == EDialogAction.edit ? (
            <DialogTitle>Edit Job Title :{props.data.id}</DialogTitle>
          ) : (
            <></>
          )}
          {props.dialogAction == EDialogAction.create ? (
            <DialogTitle>Create Job Title </DialogTitle>
          ) : (
            <></>
          )}
          {props.dialogAction == EDialogAction.view ? (
            <DialogTitle>View Job Title :{props.data.id}</DialogTitle>
          ) : (
            <></>
          )}
          <DialogContent>
            <Formik
              enableReinitialize
              validateOnMount
              initialValues={
                props.dialogAction == EDialogAction.create
                  ? {
                    id: +"",
                    title: "",
                    type: "dom",
                    pdf_template: "non_exp", // Set default value
                  }
                  : jobTitle
              }
              initialTouched={{ zip: true }}
              validationSchema={Yup.object().shape({
                title: Yup.string()
                  .required("Title is Required")
                  .max(125, "Title must not be greater than 15 characters"),

                type: Yup.string()
                  .max(8, "Type must not be greater than 8 characters")
                  .required("Type is Required"),
              })}
              onSubmit={
                props.dialogAction == EDialogAction.create
                  ? createJobTitle
                  : editJobTitle
              }
              innerRef={formRef}
            >
              {({
                handleChange,
                handleBlur,
                handleSubmit,
                values,
                touched,
                errors,
              }) => (
                <div className="grid grid-cols-2 mt-4">
                  <div className="flex flex-col space-y-1 mr-6 mb-4">
                    <TextField
                      disabled={props.dialogAction == EDialogAction.view}
                      id="outlined-multiline-flexible"
                      multiline
                      maxRows={2}
                      variant="outlined"
                      onChange={handleChange}
                      value={values.title}
                      placeholder="Enter Title"
                      label="Title"
                      required
                      name="title"
                      error={Boolean(errors.title && touched.title)}
                      helperText={
                        errors.title && touched.title && String(errors.title)
                      }
                    />
                  </div>

                  <div className="flex flex-col space-y-1 mr-6 mb-4">
                    <div>
                      <FormControl>
                        <InputLabel id="demo-simple-select-standard-label">Type</InputLabel>
                        <Select
                          disabled={props.dialogAction == EDialogAction.view}
                          style={{ width: 250, }}
                          id="type"
                          labelId="demo-simple-select-standard-label"
                          label="Type"
                          defaultValue="dom"
                          value={values.type}
                          onChange={handleChange}
                          name="type"
                          error={Boolean(touched.type && errors.type)}
                        >
                          <MenuItem value={"dom"}>Domestic</MenuItem>
                          <MenuItem value={"corp"}>Corporate</MenuItem>
                        </Select>
                      </FormControl>
                      <FormHelperText style={{ color: "red" }}>
                        {errors.type && touched.type && String(errors.type)}
                      </FormHelperText>
                    </div>
                  </div>

                  <div className="flex flex-col space-y-1 mr-6 mb-4">
                    <div>
                      <FormControl>
                        <InputLabel id="pdf-type-select-label">PDF Type</InputLabel>
                        <Select
                          disabled={props.dialogAction == EDialogAction.view}
                          style={{ width: 250 }}
                          id="pdf_template"
                          labelId="pdf-type-select-label"
                          label="PDF Type"
                          defaultValue="non_exp" // Set default value
                          value={values.pdf_template}
                          onChange={handleChange}
                          name="pdf_template"
                          error={Boolean(touched.pdf_template && errors.pdf_template)}
                        >
                          {Object.entries(pdfTypeEnum).map(([key, value]) => (
                            <MenuItem key={key} value={key}>{value.label}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <FormHelperText style={{ color: "red" }}>
                        {errors.pdf_template && touched.pdf_template && String(errors.pdf_template)}
                      </FormHelperText>
                    </div>
                  </div>

                  <div>
                    <div className="flex space-x-4">
                      {props.dialogAction != EDialogAction.view ? (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            handleSubmit();
                          }}
                        >
                          {props.dialogAction == EDialogAction.edit ? "Update " : "Create"}
                        </Button>
                      ) : null}
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          handleClose();
                        }}
                      >
                        Close
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default JobTiltlesDialogBox;
